import styled from 'styled-components';

import { ZIndex } from '../../../../enums';
import { StyledComponent } from '../../../../interfaces';
import { Toast } from '../../../toast/toast.component';

export const Container: StyledComponent<'div'> = styled.div`
  position: fixed;
  bottom: 12px;
  right: 12px;
  z-index: ${ZIndex.Toasts};
  width: calc(100% - 24px);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const StyledToast: StyledComponent<typeof Toast> = styled(Toast)`
  & + & {
    margin-top: 5px;
  }
`;
